import React, { useEffect, useState } from "react";
import styles from "./login.module.css";
import { HiOutlineKey } from "react-icons/hi2";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Url } from "../../Constants/globals";
import Alert from "../../Components/Alert/alert";
import Loading from "../../Components/Loading/loading";

function ResetPassword() {
  const { token } = useParams();
  const [dontShowPage, setDontShowPage] = useState(true);
  const [loading, setLoading] = useState("");
  const [alert, setAlert] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");

  async function tokenValidation() {
    try {
      await axios
      .get(`${Url}/users/change-password/?token=${token}`);
      return setDontShowPage(false);
    }
    catch {
      return window.location = "/404";
    };
  }

  useEffect(() => {
    tokenValidation();
  }, []);
  
  const handleChangePassword = async () => {
    await setAlert("");
    if (password1 !== password2) {
      return setAlert(<Alert type={"error"}>As palavras-passe não coincidem</Alert>);
    }
    else if (password1.length < 8) {
      return setAlert(<Alert type={"error"}>A palavra-passe deverá ser constituída por pelo menos 8 caracteres</Alert>);
    }
    await setLoading(<Loading/>);
    changePassword().then(() => {
      setAlert(<Alert type={"success"}>Palavra-passe alterada com sucesso</Alert>);
      setTimeout(() => {
        setLoading();
        window.location = "/";
      }, 1000);
    }).catch((err) => {
      setLoading();
      setAlert(<Alert type={"error"}>{err?.response?.data?.detail ? err.response.data.detail : "Ocorreu um erro ao alterar a palavra-passe"}</Alert>);
    });
  };

  const changePassword = async () => {
    await axios.post(Url + "/users/change-password/", {
      new_password: password1,
      token: token.toString()
    });
  };

  return (
    dontShowPage ?
    "" :
    <div className={styles.body}>
      {loading}
      {alert}
      <div className={styles.blur}/>
      <div className={styles.center}>
        <div className={styles.box}>
          <div className={styles.logo}/>
          <div className={styles.column}>
            <div className={styles.boxInput}>
              <HiOutlineKey className={styles.iconsColor} />
              <input
                type="password"
                className={styles.inputText}
                placeholder={"Nova palavra-passe"}
                onChange={(e) => setPassword1(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleChangePassword();
                  }
                }}
              />
            </div>
            <div className={styles.boxInput}>
              <HiOutlineKey className={styles.iconsColor} />
              <input
                type="password"
                className={styles.inputText}
                placeholder={"Confirmar palavra-passe"}
                onChange={(e) => setPassword2(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleChangePassword();
                  }
                }}
              />
            </div>
          </div>
          <div className={styles.columnBtn}>
            <button className={styles.btn} onClick={() => handleChangePassword()}>Alterar</button>
            <div className={styles.centerText}>
              <span onClick={() => window.location = "/"}>Regressar ao login</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;